import NewslettersMain from "../components/newsletters/newslettersMain";

function Boletin() {
  return ( 
    <NewslettersMain></NewslettersMain>  
  );
}

export default Boletin;
